export default "/assets/94d86e48b5d461f1.png"